import React from "react";
import { SocialLogin } from "../../../api/user";
import { useGoogleLogin } from "@react-oauth/google";
import "./Login.css";
import googleImg from "../../../images/Google.png";
import { useAuth } from "../../../context/AuthContext";
import store from "../../../store";
import { setUser as setUserRedux, clearUser } from "../../../store/userSlice";
import secureStorage from "../../../utils/secureStorage";

const GoogleButton = () => {
  const { setUser, setIsAuthenticated } = useAuth();
  const responseMessage = (response) => {
    getTokenInfo(response?.access_token);
  };

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => responseMessage(codeResponse),
  });

  const getTokenInfo = async (token) => {
    try {
      const response = await fetch(
        `https://www.googleapis.com/oauth2/v3/userinfo?access_token=${encodeURIComponent(
          token
        )}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      const socialData = {
        social_id: data?.sub,
        email: data?.email,
        social_type: 2,
        first_name: data?.given_name,
        last_name: data?.family_name,
        type: 2,
      };

      LoginUser(socialData);
    } catch (error) {
    }
  };

  const LoginUser = (data) => {
    SocialLogin(data)
      .then((response) => {
        const userData = {
          ...response.data.data,
        };
        if (response.data.status === 200) {
          secureStorage.setItem("token", response.data.access_token);

          setUser(userData);
          setIsAuthenticated(true);
          secureStorage.setItem("accessToken", userData.access_token);
          secureStorage.setJSON("user", userData);
          secureStorage.setItem("isLoggedIn", "true");
          store.dispatch(setUserRedux(userData));
          window.location.href = "/";
        } else {
          store.dispatch(clearUser());
          setUser(null);
          setIsAuthenticated(false);
          secureStorage.removeItem("token");
          secureStorage.removeItem("accessToken");
          secureStorage.removeItem("user");
          secureStorage.removeItem("isLoggedIn");
        }
      })
      .catch((error) => {});
  };

  return (
    <>
      <div className="googleLoginButton" style={{ width: "100%" }}>
        <button
          onClick={() => login()}
          className="mt-1 secondary-button text-primaryColor items-center justify-center h-11 border border-gray-300"
        >
          <span className="font-bold text-2xl px-1">
            <img src={googleImg} alt="Google" className="w-6 h-6" />
          </span>
        </button>
      </div>
    </>
  );
};

export default GoogleButton;
